import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {},
    headerWrapper: {
        paddingTop: theme.spacing(7),
        paddingBottom: theme.spacing(7),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(3.75),
            paddingBottom: theme.spacing(3.75),
        },
    },
    headerDescriptionWrapper: {
        paddingLeft: theme.spacing(8),
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
        },
    },
    headerDescriptionInfo: {
        marginTop: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(1),
        },
    },
    illustrationWrapper: {
        flexGrow: 1,
        [theme.breakpoints.down('md')]: {
            maxWidth: 300,
            width: 300,
            marginTop: theme.spacing(5),
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: 250,
            width: 250,
            marginTop: theme.spacing(3),
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: 200,
            width: 200,
        },
    },
    secondDescriptionWrapper: {
        flexGrow: 1,
        [theme.breakpoints.down('md')]: {},
        [theme.breakpoints.down('xs')]: {},
    },
    pageContentWrapper: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
    },
}));
